import generateUUID from 'uuid/v1';

export default generateUUID();
